tmPageAnimate = function () {
    return {
        fireWorks: function () {
            try {
                var pageAnimateFireworks__duration = 15 * 1000;
                var pageAnimateFireworks__animationEnd = Date.now() + pageAnimateFireworks__duration;
                var pageAnimateFireworks__defaults = {
                    startVelocity: 30,
                    spread: 360,
                    ticks: 60,
                    zIndex: 0
                };

                function pageAnimateFireworks__randomInRange(min, max) {
                    return Math.random() * (max - min) + min;
                }

                var pageAnimateFireworks__interval = setInterval(function () {
                    var pageAnimateFireworks__timeLeft = pageAnimateFireworks__animationEnd - Date.now();

                    if (pageAnimateFireworks__timeLeft <= 0) {
                        return clearInterval(pageAnimateFireworks__interval);
                    }

                    var pageAnimateFireworks__particleCount =
                        50 * (pageAnimateFireworks__timeLeft / pageAnimateFireworks__duration);

                    confetti({
                        ...pageAnimateFireworks__defaults,
                        particleCount: pageAnimateFireworks__particleCount,
                        origin: {
                            x: pageAnimateFireworks__randomInRange(0.1, 0.3),
                            y: Math.random() - 0.2
                        }
                    });

                    confetti({
                        ...pageAnimateFireworks__defaults,
                        particleCount: pageAnimateFireworks__particleCount,
                        origin: {
                            x: pageAnimateFireworks__randomInRange(0.7, 0.9),
                            y: Math.random() - 0.2
                        }
                    });
                }, 250);
            } catch (e) {}
        },

        snow: function () {
            try {
                var pageAnimateSnow__duration = 15 * 1000;
                var pageAnimateSnow__animationEnd = Date.now() + pageAnimateSnow__duration;
                var pageAnimateSnow__skew = 1;

                function pageAnimateSnow__randomInRange(min, max) {
                    return Math.random() * (max - min) + min;
                }

                (function pageAnimateSnow__frame() {
                    var pageAnimateSnow__timeLeft = pageAnimateSnow__animationEnd - Date.now();
                    var pageAnimateSnow__ticks = Math.max(
                        200,
                        500 * (pageAnimateSnow__timeLeft / pageAnimateSnow__duration)
                    );

                    pageAnimateSnow__skew = Math.max(
                        0.8,
                        pageAnimateSnow__skew - 0.001
                    );

                    confetti({
                        particleCount: 1,
                        startVelocity: 0,
                        ticks: pageAnimateSnow__ticks,
                        origin: {
                            x: Math.random(),
                            // since particles fall down, skew start toward the top
                            y: (Math.random() * pageAnimateSnow__skew) - 0.2
                        },
                        colors: ['#ffffff'],
                        shapes: ['circle'],
                        gravity: pageAnimateSnow__randomInRange(0.4, 0.6),
                        scalar: pageAnimateSnow__randomInRange(0.4, 1),
                        drift: pageAnimateSnow__randomInRange(-0.4, 0.4)
                    });

                    if (pageAnimateSnow__timeLeft > 0) {
                        requestAnimationFrame(pageAnimateSnow__frame);
                    }
                }());
            } catch (e) {}
        },

        school: function () {
            try {
                var pageAnimateSchool__end = Date.now() + (15 * 1000);
                var pageAnimateSchool__colors = ['#bb0000', '#ffffff'];

                (function pageAnimateSchool__frame() {
                    confetti({
                        particleCount: 2,
                        angle: 60,
                        spread: 55,
                        origin: { x: 0 },
                        colors: pageAnimateSchool__colors
                    });

                    confetti({
                        particleCount: 2,
                        angle: 120,
                        spread: 55,
                        origin: { x: 1 },
                        colors: pageAnimateSchool__colors
                    });

                    if (Date.now() < pageAnimateSchool__end) {
                        requestAnimationFrame(pageAnimateSchool__frame);
                    }
                }());
            } catch (e) {}
        }
    }
}(window);
